import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getMapMarkers } from '../../services/map.service';
import MapWithMarkers, {
  MarkerInfo
} from '../map-with-markers/map-with-markers';
import MapNavbar from '../navbars/map-navbar';
import useMapBounds from '../map/use-map-bounds';

const MapPage = () => {
  const { id, folderid } = useParams<{ id: string; folderid: string }>();
  const [markers, setMarkers] = useState<MarkerInfo[]>([]);

  const { centerPosition, zoom } = useMapBounds(markers); // Use the custom hook

  useEffect(() => {
    const fetchMapDetails = async () => {
      try {
        if (id) {
          const response = await getMapMarkers(id, folderid || '');
          setMarkers(response.data.markers);
        }
      } catch (error) {
        console.error('Error fetching place details:', error);
      }
    };

    fetchMapDetails();
  }, [id]);

  const memoizedMarkers = useMemo(() => markers, [markers]);

  return (
    <div className='map-page container-px'>
      <MapNavbar itemCount={memoizedMarkers.length} />
      <div className='map-page-container'>
        <div className='map-page-container-left'>
          {centerPosition.lat !== 0 && centerPosition.lng !== 0 && (
            <MapWithMarkers
              tripId={id || ''}
              folderId={folderid || ''}
              markers={memoizedMarkers}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MapPage;
